import React from 'react';
import { Routes, Route } from "react-router-dom";

// Layouts
import PublicLayout from "./Common/Layout/PublicLayout";
import AdminLayout from "./Common/Layout/AdminLayout";
import CustomerLayout from './Common/Layout/CustomerLayout';


// Pages

import Home from "./Common/Layout/Home";
import SalonMaster from "./Components/Master/Salon";
import Salon from './Components/Master/Salon';
import Customer from './Components/Master/Customer';
import Staff from './Components/Master/Staff';
import BusinessLayout from './Common/Layout/BusinessLayout';
import Category from './Components/Master/Category';
import Services from './Components/Master/Services';
import SalonTimings from './Components/Master/SalonTimings';
import RegisterSalon from './Authentication/RegisterSalon';
import Brand from './Components/Master/Brand';
import Product from './Components/Master/Product';
import ProductImage from './Components/Master/ProductImage';
import BusinessDashboard from './Dashboards/BusinessDashboard';
import AdminDashboard from './Dashboards/AdminDashboard';
import Profile from './Authentication/Profile';
import ChangePassword from './Authentication/ChangePassword';
import CustomerDashboard from './Dashboards/CustomerDashboard';
import SalonStaff from './Components/Business/SalonStaff';
import SalonService from './Components/Business/SalonService';
import BookService from './Components/Customer/BookService';
import RegisterCustomer from './Authentication/RegisterCustomer';
import Appointments from './Components/Master/Appointments';
import ProductView from './Components/Master/ProductView';
import AdminOrders from './Components/Master/AdminOrders';
import ServicesList from './Components/Master/ServicesList';
import SalonsList from './Components/Master/SalonsList';
import AppointmentsList from './Components/Business/AppointmentList';
import ProductsList from './Components/Master/ProductsList';
import CustomerOrders from './Components/Customer/CustomerOrders';
import CustomerAppointments from './Components/Customer/CustomerAppointments';
import AboutUs from './Common/Layout/AboutUs';
import ContactUs from './Common/Layout/ContactUs';
import AllCategories from './Common/Layout/AllCategories';
import SalonByCategory from './Common/Layout/SalonByCategory';
import AdminProfile from './Authentication/AdminProfile';
import CustomerProfile from './Authentication/CustomerProfile';
import BusinessProfile from './Authentication/BusinessProfile';
import AddCart from './Components/Customer/addcart';
import Categories from './Common/Layout/Categories';
import CustomerAddCart from './Components/Customer/CustomerAddCart';
import CustomerBookService from './Components/Customer/CustomerBookService';









function App() {
  return (
    <Routes>
      {/* PUBLIC SITE */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/register-business" element={<RegisterSalon />} />
        
      
        <Route path="/register-customer" element={<RegisterCustomer />} />
        <Route path="/services/search" element={<ServicesList />} />
        <Route path="/salons/search" element={<SalonsList />} />
        <Route path="/product-view/:id" element={<ProductView />} />
        <Route path="/products/search" element={<ProductsList />} />
        <Route path="/product-details/:id" element={<ProductView />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/all-categories" element={<AllCategories />} />
<Route path="/salons-by-category/:categoryId/:categoryName" element={<SalonByCategory />} />
<Route path="/book-service" element={<BookService />} />
<Route path="/cart" element={<AddCart />} />
<Route path="/all-categories" element={<Categories />} />



      </Route>
      <Route element={<AdminLayout />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} /> {/* Admin Dashboard */}
        <Route path="/salons" element={<Salon />} />
        <Route path="/customers" element={<Customer />} />
        <Route path="/staffs" element={<Staff />} />
        <Route path="/category" element={<Category />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/SalonTimings" element={<SalonTimings />} />
        <Route path="/Brand" element={<Brand />} />
        <Route path="/Product" element={<Product />} />
        <Route path="/ProductImage" element={<ProductImage />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/changepassword" element={<ChangePassword/>} />
        <Route path="/appointments" element={<Appointments />} />
        
        <Route path="/orders" element={<AdminOrders />} />
        <Route path="/product-view/:id" element={<ProductView />} />
        


      </Route>
   
     <Route element={<BusinessLayout />}>
        <Route path="/business/dashboard" element={<BusinessDashboard />} />
        <Route path="/business/customers" element={<Customer />} />
        <Route path="/business/staffs" element={<SalonStaff />} />
        <Route path="/business/Services" element={<SalonService />} />
        <Route path="/business/profile" element={<BusinessProfile />} />
        <Route path="/business/changepassword" element={<ChangePassword />} />
        <Route path="/business/appointmentslist" element={<AppointmentsList />} />
      </Route>

      <Route element={<CustomerLayout />}>
        <Route path="/customer/dashboard" element={<CustomerDashboard />} />
        <Route path="/customer/products/search" element={<ProductsList />} />
        <Route path="/customer/service" element={<CustomerBookService />} />
        <Route path="/customer/salons/search" element={<SalonsList />} />
        <Route path="/customer/profile" element={<CustomerProfile />} />
        <Route path="/customer/changepassword" element={<ChangePassword />} />
        <Route path="/customer/orders" element={<CustomerOrders/>} />
      <Route path="/customer/appointments" element={<CustomerAppointments/>} />
      <Route path="/customer/cart" element={<CustomerAddCart />} />
      <Route path="/customer/book-service" element={<CustomerBookService />} />

      
    </Route>
    </Routes>
  );
}

export default App;